import { customAxios, PROFORMA_URL,FDV_URL, STOCK_URL, IDUSUARIO, USERNAME } from '../constants';
import { FETCH_EQUIPOS_LOGISTICA, FETCH_EQUIPOS_LOGISTICA_DETALLE, FETCH_EQUIPOS_LOGISTICA_GRABAR } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchEquiposLogisticaDetalle(codProforma,estadoTrama,mensaje,numerodePaginas,totalRegistros) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO
    },
    params: {

    },
  };

  const data = {
      codProforma:codProforma,
      estadoTrama:estadoTrama,
      mensaje:mensaje,
      numerodePaginas:numerodePaginas,
      totalRegistros:totalRegistros
  };

  const request = customAxios.post(`${PROFORMA_URL}/proforma/detalleListar`, data, config)
                              .then(({ data }) => evalAction(data, 'detalleListar'))
                              .catch(error => serverError(error, 'detalleListar'));

  return {
    type: FETCH_EQUIPOS_LOGISTICA_DETALLE,
    payload: request,
  };

}

export function fetchEquiposAdicionales(
    codAreaVta,
    codBaumuster,
    codCia,
    codEquipo,
    codFamilia,
    codMarca,
    codProveedor,
    descEquipo,
    subTipoEquipo,
    tipoCambio,
    tipoEquipo,
    tipoMoneda,
    numPag,
    cantidadxPag
) {

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario:USERNAME,
      numPag:numPag,
      cantidadxPag:cantidadxPag
    },
    params: {

    }

  };
    const data = {
    codAreaVta: codAreaVta,
    codBaumuster: codBaumuster,
    codCia: codCia,
    codEquipo: codEquipo,
    codFamilia: codFamilia,
    codMarca: codMarca,
    codProveedor: codProveedor,
    descEquipo: descEquipo,
    subTipoEquipo: subTipoEquipo,
    tipoCambio: tipoCambio,
    tipoEquipo: tipoEquipo,
    tipoMoneda: tipoMoneda

  }


  const request = customAxios.post(`${STOCK_URL}/equipo/localListar`, data, config)
                              .then(({ data }) => evalAction(data, 'localListar'))
                              .catch(error => serverError(error, 'localListar'));

  return {
    type: FETCH_EQUIPOS_LOGISTICA,
    payload: request,
  };

}

  export function grabarEquiposAdicionales(
    numero,
    codColaborador,
    codCortesiaComercial,
    codEquipoLocalVeh,
    codMonedaEquipoLocal,
    codTipoCortesia,
    desObservacion,
    indInactivo,
    numEquipos,
    numFichaVtaVeh,
    nurFichaVtaPedido,
    tipoCorreo,
    valPrecioVta,
    valPrecioVtaTotal,
    numPedidoVeh,
    descEquipo
  ) {

    const config = {
      headers: {
        idUsuario: IDUSUARIO,
        codUsuario:USERNAME
      },
    };
      const data = {
        numPedidoVeh:numPedidoVeh=== null?'':numPedidoVeh,
        codColaborador:codColaborador,
        codCortesiaComercial: codCortesiaComercial===null?0:codCortesiaComercial,
        codEquipoLocalVeh: codEquipoLocalVeh===null?'':codEquipoLocalVeh,
        codMonedaEquipoLocal: codMonedaEquipoLocal===null?'':codMonedaEquipoLocal,
        codTipoCortesia: 5,
        desObservacion: desObservacion===null?'':desObservacion.replace(/\n/g, "<br />"),
        indInactivo: indInactivo===null?'':indInactivo,
        numEquipos: numEquipos===null?0:numEquipos,
        numFichaVtaVeh: numFichaVtaVeh===null?'':numFichaVtaVeh,
        nurFichaVtaPedido: nurFichaVtaPedido===null?0:nurFichaVtaPedido,
        tipoCorreo: tipoCorreo===null?'':tipoCorreo,
        valPrecioVta: valPrecioVta===null?0:valPrecioVta,
        valPrecioVtaTotal: valPrecioVtaTotal===null?0:valPrecioVtaTotal,
        descEquipo : descEquipo===null?0:descEquipo
    }


    const request = customAxios.post(`${FDV_URL}/ficha-venta/fichas-venta/${numero}/adicionales`, data, config)
                                .then(({ data }) => evalAction(data, 'adicionales'))
                                .catch(error => serverError(error, 'adicionales'));

    return {
      type: FETCH_EQUIPOS_LOGISTICA_GRABAR,
      payload: request,
    };

}



// WEBPACK FOOTER //
// ./src/actions/EquiposLogistica.js